export default {
  faviconLight: "/WorkLife_favicon.svg",
  faviconDark: "/WorkLife_favicon.svg"
};
